
<div class="container-fluid">

    <app-header></app-header>
    
    <div class="row mt-3 d-flex justify-content-center signup-card">
        <div class="col-lg-3 col-xs-12 col-sm-12 col-md-12 col-md-mid-lg-4">
            <div class="text-center box-white">
             
                <div class=" white-bg   " style="padding-top: 40px; padding-bottom: 30px;">
                    <h5 class="text-center payment-danger pb-4 lato-text"><b> Payment failed! </b>  </h5> 
                   

                     <p class=" lato-text" style="padding-bottom: 100px;">  Sorry! We were unable to process the payment <br/>using Koko. Please have the customer try again <br/>or contact us for further information.  </p> 
                    
                    <button class="btn btn-secondary form-control back-to-cas no-border-radius " (click)="backtohome()"> <b> BACK TO CASHIER PORTAL </b></button>
                </div> 
                
            </div>
             
        </div>
        <div class="col-lg-9 col-md-mid-lg-8"> 
            &nbsp;
        </div>
    </div>
 
  
</div>



<div class="foter-mr-pd-fix ">
    <app-footer></app-footer>
</div>